<div class="form-field">
  @if (name) {
    <label class="label" [class.bold]="bold" [attr.for]="inputId">
      <span>{{name}}</span>
    </label>
  }
  @if (copy || isPassword) {
    <div class="buttons">
      @if (copy) {
        <button type="button" class="btn btn-link" [appCopyValue]="control.value">
          <span class="copied-hide">{{copyText}}</span>
          <span class="copied-show">Copied</span>
        </button>
      }
      @if (isPassword) {
        <button type="button" class="btn btn-link" (click)="toggleMasking()">
          {{masked ? 'Show' : 'Hide'}} {{labelName}}
        </button>
      }
    </div>
  }
  <input
    [id]="inputId"
    [type]="formControlType"
    [placeholder]="placeholder"
    [formControl]="control"
    class="form-control"
    [class.valid-icon]="!readonly"
    [class.invalid-icon]="!readonly"
    [readonly]="readonly"
    [autocomplete]="autocomplete"
    >
  <div class="actions">
    <ng-content></ng-content>
  </div>
  @if (showError) {
    <div class="input-error">
      <span>{{errorPresentation}}</span>
    </div>
  }
</div>
